<template>
    <!--
            作者：kmdshop
            时间：2020-04-20
            描述：修改价格
        -->
    <el-dialog title="赠送商品" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="70%"   :append-to-body="true">
               <el-table  :data="send_products" style="width: 100%" border>
      
                <el-table-column prop="product_name" label="商品"></el-table-column>
                        <el-table-column prop="spec_value" label="规格"></el-table-column>
                        <el-table-column prop="unit" label="计量单位"></el-table-column>
                
                        </el-table-column>
                        <el-table-column prop="product_price" label="单价">
                            <template slot-scope="scope">
                            
                        {{ scope.row.product_price }}
                            </template>

                        </el-table-column>
                        <el-table-column prop="set_num" label="赠送数量">

                        </el-table-column>

                        </el-table>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>

        </div>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    export default {
        data() {
            return {
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: false,
                /*表单*/
                order: {
                    update_price: 0,
                    update_express_price: 0.00,
                }
            };
        },
        props: ['open_edit','send_products'],
        created() {
            this.dialogVisible = this.open_edit
         
        },
        methods: {
//        

            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('close', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/sp.vue